import { Component, OnInit } from '@angular/core';
import { ScrollService } from '../../scroll.service';


@Component({
	selector: 'portals-trusted-by-carousel',
	templateUrl: './trusted-by-carousel.component.html',
	styleUrls: ['./trusted-by-carousel.component.scss'],
})
export class TrustedByCarouselComponent implements OnInit {
	logos: string[] = [
		'/assets/images/aclu-black.png',
		'/assets/images/impactmentorsfoundation.png',
		'/assets/images/nulawlab-black.png',
		'/assets/images/alliancenebraska-black.png',
		'/assets/images/governmenttechnology.png',
		'/assets/images/cityoftallahassee-black.png',
		'/assets/images/cityoflongbeach-black.png',
		'/assets/images/universitysettlement-black.png',
		'/assets/images/naacp.png',
		'/assets/images/logo-second.png',
	  ];
	  constructor(private scrollService: ScrollService) {}

	  scrollToTarget() {
		this.scrollService.triggerScroll();
	  }

	  ngOnInit(): void {}


}
